import { IStyle } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IEditFeatureListStyles {
  root?: IStyle;
  subTitle?: IStyle;
  subTitleText?: IStyle;
  subTitleError?: IStyle;
  list?: IStyle;
}

export interface IEditFeatureListClassNames {
  root: string;
  subTitle: string;
  subTitleText: string;
  subTitleError: string;
  list: string;
}

export const editFeatureListStylesDefault = (theme: IH2OTheme): Partial<IEditFeatureListStyles> => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '150px',
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  subTitleText: {
    lineHeight: '32px',
  },
  subTitleError: {
    color: theme.semanticColors?.inputErrorMessageText,
    fontWeight: FontWeights.normal,
  },
  list: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
});
